<div class="mt-6 d-flex flex-column">
  <div class="listview">
    <div class="listview-header row">
      <div
        class="col-5"
        baseTruncate
      >
        {{ 'name' | translate }}
      </div>
      <div
        class="col-3"
        baseTruncate
      >
        {{ 'category' | translate }}
      </div>
      <div
        class="col-2"
        baseTruncate
      >
        {{ 'dateTime.validUntil' | translate }}
      </div>
      <div class="col-2"></div>
    </div>
    <div
      *ngFor="let document of documentList"
      class="listview-item cursor-auto mb-5 bg-lightest"
    >
      <base-customer-offer-document
        [document]="document"
        [offer]="offer"
      ></base-customer-offer-document>
    </div>
    <base-empty-list-row
      *ngIf="!documentList.length"
      message="document.noOfferDocuments"
      [hideBackgroundImage]="true"
      [backgroundSecondary]="true"
    ></base-empty-list-row>
  </div>
</div>
